import React, { useState } from "react";
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useDonation } from '../../context/DonationContext';
import OtherAmount from '../donation/OtherAmount';
import HandImage from '../../assets/images/hand.svg';
import Hand2Image from '../../assets/images/hand2.svg';
import ColorsImage from '../../assets/images/colors.svg';

export default function DonationAmountSelector({ id }) {
    const [showOtherAmount, setShowOtherAmount] = useState(false);
    const navigate = useNavigate();
    const { updateDonation } = useDonation();

    const handleDonateClick = (amount) => {
        updateDonation({ amount });
        navigate('/donar/informacion');
    };

    const glowTransition = {
        duration: 3,
        ease: "easeInOut",
        repeat: Infinity,
    };

    return (
        <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            viewport={{ once: true, amount: 0.4 }}
            id={id} className="bg-white relative flex justify-center w-full mx-auto lg:py-0 scroll-mt-40"
        >
            <div>
                <div className="mb-10 lg:mb-0">
                    <p className="text-4xl font-bold lg:text-8xl w-full text-center z-10 relative">¿Quieres donar?</p>
                    <img
                        src={Hand2Image}
                        alt="2da mano"
                        className="absolute top-[78px] left-[16px] lg:top-[129px] lg:left-[323px] w-28 lg:w-80 z-0 pointer-events-none"
                    />
                    <img
                        src={ColorsImage}
                        alt="Separador Colores"
                        className="absolute top-[108px] left-[93px] lg:top-[269px] lg:left-[523px] w-20 lg:w-70 z-0 pointer-events-none"
                    />
                    <div className="lg:text-right text-right mr-9">
                        <span className="inline-block bg-idarkblue text-white text-2xl font-lato font-bold lg:text-6xl lg:p-2  z-10 relative">¡Elige un monto!</span>
                        <img
                            src={HandImage}
                            alt="Creativo Mano"
                            className="absolute top-[-13px] right-[10px] lg:top-[-27px] lg:right-[167px] w-40 lg:w-96 z-0 pointer-events-none"
                        />
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-4 lg:gap-6 lg:max-w-1/12 max-w-10/12 mx-auto mt-16 lg:mt-36 pl-16 lg:pl-60">
                    <div className="flex flex-col gap-5 lg:gap-10 items-end">
                        {[{ amount: 100, label: 'MXN', bgcolor: 'bg-ipink' }, { amount: 500, label: 'MXN', bgcolor: 'bg-ipink' }].map(({ amount, label, bgcolor }) => (
                            <motion.button
                                key={amount}
                                animate={{
                                    scale: [1, 1.05, 1],
                                    boxShadow: [
                                        '0 0 10px 2px rgba(118, 60, 190, 0)',         // sin glow
                                        '0 0 20px 6px rgba(118, 60, 190, 0.6)',      // glow morado
                                        '0 0 10px 2px rgba(118, 60, 190, 0)',         // sin glow
                                    ],
                                }}
                                transition={glowTransition}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => handleDonateClick(amount)}
                                className={`${bgcolor} border-2 w-11/12 border-black text-white font-lato font-bold py-1 rounded-xl hover:bg-ipurple transition duration-200 group`}
                            >
                                <div className="flex flex-col items-center">
                                    <span className="block lg:text-5xl text-2xl mx-8">${amount}</span>
                                    <span className="block text-xs font-normal text-white">{label}</span>
                                </div>
                            </motion.button>
                        ))}
                    </div>
                    <div className="flex flex-col gap-5 lg:gap-10">
                        {[{ amount: 200, label: 'MXN', bgcolor: 'bg-idarkblue' }, { amount: 1000, label: 'MXN', bgcolor: 'bg-idarkblue' }].map(({ amount, label, bgcolor }) => (
                            <motion.button
                                key={amount}
                                animate={{
                                    scale: [1, 1.05, 1],
                                    boxShadow: [
                                        '0 0 10px 2px rgba(118, 60, 190, 0)',
                                        '0 0 20px 6px rgba(118, 60, 190, 0.6)',
                                        '0 0 10px 2px rgba(118, 60, 190, 0)',
                                    ],
                                }}
                                transition={glowTransition}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => handleDonateClick(amount)}
                                className={`${bgcolor} border-2 w-11/12 border-black text-white font-lato font-bold py-1 px-1 rounded-xl hover:bg-ipurple transition duration-200 group`}
                            >
                                <div className="flex flex-col items-center">
                                    <span className="block lg:text-5xl text-2xl">${amount}</span>
                                    <span className="block text-xs font-normal text-white">{label}</span>
                                </div>
                            </motion.button>
                        ))}
                    </div>
                </div>

                <div className="mt-8 text-center">
                    {showOtherAmount ? (
                        <OtherAmount handleDonateClick={handleDonateClick} />
                    ) : (
                        <motion.button
                            onClick={() => setShowOtherAmount(true)}
                            className="text-blue-600 font-medium hover:underline flex items-center justify-center mx-auto gap-2"
                            whileHover={{ scale: 1.05 }}
                        >
                            <span>✨</span>
                            <span>Otro monto</span>
                        </motion.button>
                    )}
                </div>
            </div>
        </motion.div>
    );
}
